import React from 'react';

type ButtonProps = {
  onClick: () => void;
  disabled: boolean;
  label: string;
  style?: object;
};
const PrimaryButton = ({ onClick, disabled, label, style }: ButtonProps) => {
  return (
    <button
      className={`flex w-full justify-center rounded-md ${disabled ? 'bg-indigo-300' : 'bg-indigo-600'} px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs ${disabled ? '' : 'hover:bg-indigo-500'} focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 mt-2`}
      style={style || {}}
      disabled={disabled}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default PrimaryButton;
